import type { AxiosInstance } from 'axios';
import {
  createApiClient,
  API_BASE_URL,
  type ApiClientHandlers,
} from './client';

const API_CLIENT_ERROR = {
  NOT_INITIALIZED:
    'Api client not initialized. Call initApiClient() during app bootstrap.',
  NOT_INITIALIZED_BEFORE_RECREATE:
    'Api client not initialized. Call initApiClient() during app bootstrap before recreateApiClient().',
} as const;

let apiInstance: AxiosInstance | null = null;
let storedHandlers: ApiClientHandlers | null = null;

export function initApiClient(handlers: ApiClientHandlers): void {
  storedHandlers = handlers;
  const result = createApiClient(handlers);
  apiInstance = result.api;
}

export function recreateApiClient(): void {
  if (storedHandlers === null) {
    throw new Error(API_CLIENT_ERROR.NOT_INITIALIZED_BEFORE_RECREATE);
  }
  const result = createApiClient(storedHandlers);
  apiInstance = result.api;
}

function getApiClient(): AxiosInstance {
  if (apiInstance === null) {
    throw new Error(API_CLIENT_ERROR.NOT_INITIALIZED);
  }
  return apiInstance;
}

const api = new Proxy({} as AxiosInstance, {
  get(_, prop) {
    return (getApiClient() as unknown as Record<string, unknown>)[prop as string];
  },
});

export { api, API_BASE_URL, createApiClient, type ApiClientHandlers };
export {
  connectRealtime,
  disconnectRealtime,
  emitRealtimeEvent,
  isRealtimeActive,
  onRealtimeEvent,
} from './realtime';
export default api;
